import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Button, Header, InputTextArea, Modal, Text } from "@pentabd/ui";

import { SelectEmployee } from "@components";

import { DECISION_TYPE } from "@constants/workflow-decision-type";

const { FORWARD } = DECISION_TYPE;
interface ActionModalType {
  title: string;
  subtitle?: string | undefined;
  isModalOpen: boolean;
  closeModal: () => void;
  handleExecutionAction?: (arg: string) => void;
  handleRecommendationAction?: (arg: string) => void;
  isLoading?: boolean;
}

export const ActionModal = ({
  title,
  subtitle,
  isModalOpen,
  closeModal,
  handleRecommendationAction,
  handleExecutionAction,
  isLoading,
}: ActionModalType) => {
  const { t } = useTranslation();

  const methods = useForm();
  const { watch, register, handleSubmit } = methods;

  const onSubmit = (data: any) => {
    handleRecommendationAction && handleRecommendationAction(data);
    handleExecutionAction && handleExecutionAction(data);
  };

  return (
    <Modal
      isOpen={isModalOpen}
      overlay={isModalOpen}
      onClose={closeModal}
      closeAble
    >
      <Header
        size="sm"
        headerText={{
          header: title,
          subHeader: subtitle ? subtitle : "",
        }}
        className="px-9"
      />
      <div className="px-10 py-9 border-bottom">
        <FormProvider {...methods}>
          <form className="container" onSubmit={handleSubmit(onSubmit)}>
            {title === FORWARD && (
              <div className="pb-7">
                <SelectEmployee
                  registeredName="nextReviewerId"
                  selectSingleEmployee
                  forModal
                />
              </div>
            )}
            <Text color="dark" weight="semibold">
              {t("RETIREMENT.MODAL.APPROVE_COMMENT_LABEL.FIRST_PART")}
              <Text size="sm" color="subtitle3" weight="medium">
                &nbsp;
                {t("RETIREMENT.MODAL.APPROVE_COMMENT_LABEL.SECOND_PART")}
              </Text>
            </Text>
            <InputTextArea
              {...register("actionComment")}
              placeholder={t("RETIREMENT.MODAL.APPROVE_COMMENT")}
              className="my-7"
            />
            <div className="border-top py-9 d-flex justify-content-end align-items-center gap-6">
              <Button
                size="sm"
                fill="outline"
                type="light"
                onClick={closeModal}
              >
                {t("RETIREMENT.MODAL.BUTTON.CANCEL_BUTTON")}
              </Button>
              <Button
                size="sm"
                fill="fill"
                type="primary"
                htmlType="submit"
                disabled={
                  title === FORWARD &&
                  typeof watch("nextReviewerId") !== "number"
                }
                loading={isLoading}
              >
                {t("RETIREMENT.MODAL.BUTTON.SUBMIT_BUTTON")}
              </Button>
            </div>
          </form>
        </FormProvider>
      </div>
    </Modal>
  );
};
